export default "__VITE_ASSET__DWNMPIqt__"